import { Image } from "@mantine/core";
import logo from "../../assets/logo.svg";
interface Props {
  style?: React.CSSProperties;
}
export const Logo = (props: Props) => (
  <Image src={logo} style={{ width: "100%", height: "auto", ...props.style }} />
);
